<template>
    <v-dialog max-width="80%" v-model="dialog">
        <template v-slot:activator={on}>
            <v-btn text v-on=on>
                <v-icon left>mdi-plus</v-icon>Add Warehouse
            </v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title>Add Warehouse</v-card-title>
            <v-card-text>
                <v-alert v-if="errors.length > 0" type="error">
                    <p v-for="(error,idx) in errors" :key="'_err_'+idx">{{error}}</p>
                </v-alert>
                <v-form ref="addForm">
                    <v-text-field v-model="model.code" label="Code" :rules="[rules.required]" />
                    <v-text-field v-model="model.name" label="Name" :rules="[rules.required]"/>
                    <v-checkbox v-model="model.external" label="Is External ?" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="save" color="primary">Add</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () => ({
        dialog:null,
        model:{
            code:'',
            name:'',
            external:false
        },
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
        loading:false,
        errors:[]
    }),
    methods:{
        ...mapActions("warehouse", ["create"]),
        save(){
            this.errors=[]
            if (this.$refs.addForm.validate()) {
                this.loading=true
                this.create(this.model)
                .then(() => {
                    this.$emit("added")
                    this.dialog=false
                    this.model = {code:'', name:'', external:false}
                })
                .catch(({data}) => {
                    for (const error of Object.entries(data.errors)) {
                        this.errors.push(error[1][0])
                    }
                })
                .finally(() => {
                    this.loading=false
                })
            }
        }
    }
}
</script>

<style>

</style>